import React, { useState } from "react";
import { createOrderWithKeys, verifyOrderWithKeys, setRazorpayGatewayIsverfied } from "../../services/classApiServices";

const RazorPayKeys = ({ amount, callback, gymid, user, razorpayKeyId, razorpaySecret }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handlePayment = async () => {
        if (!razorpayKeyId || !razorpaySecret) {
            console.log("Please enter both Razorpay Key ID and Secret");
            return;
        }

        if (!razorpayKeyId.startsWith('rzp_test_') && !razorpayKeyId.startsWith('rzp_live_')) {
            console.log("Invalid Razorpay Key ID format. Must start with 'rzp_live_'");

            callback(null, new Error("Invalid Razorpay Key ID format"));
            return;
        }
        setIsLoading(true);
        try {
            const resdata = await createOrderWithKeys({
                amount,
                currency: "INR",
                gymid,
                razorpayKeyId,
                razorpaySecret,
                customer: {
                    name: user?.name || '',
                    email: user?.email || '',
                    contact: user?.phone || ''
                }
            });

            console.log(resdata, 'data');
            if (!resdata) {
                throw new Error("No response received from server");
            }

            if (!resdata.ok) {
                const errorData = await resdata.json().catch(() => ({ message: "Server error" }));
                throw new Error(errorData.message || `HTTP Error: ${resdata.status}`);
            }

            const orderinfo = await resdata.json();
            console.log(orderinfo, 'orderinfo');


            if (!orderinfo.success) {
                callback(null, "Invalid keys");
                return;
            }

            const data = orderinfo;
            console.log("data", data);
            if (!data.success) {
                // alert("Error creating order");
                throw new Error(orderinfo.message)
            }

            const { id: order_id, amount: order_amount, currency } = data.order;

            console.log("dataoRder", data.order);

            const options = {
                key: data.key,
                amount: order_amount,
                currency,
                name: "Verify Keys",
                description: "Payment for Verification",
                order_id,
                prefill: {
                    name: user?.name || '',
                    email: user?.email || '',
                    contact: user?.phone || ''
                },
                handler: async function (response) {
                    try {
                        const verifyinfo = await verifyOrderWithKeys({
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                            gymid: gymid,
                            razorpayKeyId,
                            razorpaySecret,
                        });

                        if (!verifyinfo || verifyinfo === "false") {
                            return;
                        }

                        const verifyRes = await verifyinfo.json();
                        console.log(verifyRes, "verifyRes");

                        if (verifyRes.success) {
                            const res = verifyRes.razorpay_order ? verifyRes.razorpay_order : null;
                            console.log(res, "parsed response");
                            callback(res, "success");
                        } else {
                            alert("Payment Verification Failed");
                            try {
                                await setRazorpayGatewayIsverfied({ gymid, isverfied: 1 });
                            } catch (e) {
                                console.warn(e);
                            }
                        }
                    } finally {
                        setIsLoading(false);
                    }
                },
                theme: {
                    color: "#3399cc",
                },
            };

            const razorpay = new window.Razorpay(options);
            razorpay.on('payment.failed', async function (response) {
                console.error("Payment failed:", response.error);
                try {
                    const r = await setRazorpayGatewayIsverfied({ gymid, isverfied: 1 });
                    if (r && r.ok) {
                        await r.json().catch(() => ({}));
                    }
                } catch (e) {
                    console.warn("Could not persist isverfied=1 (no gateway row yet):", e);
                } finally {
                    setIsLoading(false);
                }
            });

            razorpay.open();
        } catch (error) {
            console.error("Payment error:", error);
            if (error.message.includes("Invalid Razorpay credentials") ||
                error.message.includes("Authentication failed")) {
                console.log("Invalid Razorpay credentials. Please check your Key ID and Secret.");
            } else if (error.message.includes("Bad request")) {
                console.log("Invalid request parameters. Please check your Razorpay configuration.");
            } else {
                console.log(`Payment failed: ${error.message}`);
            }
            callback(null, error);
        }
        finally {
            setIsLoading(false);
        }
    };

    return (
        <button
            onClick={handlePayment}
            className="btn btn-primary"
            disabled={!razorpayKeyId || !razorpaySecret}
        >
            {isLoading ? "Processing..." : "Pay Yourself"}
        </button>
    );
};

export default RazorPayKeys;
